import { createAsyncThunk } from '@reduxjs/toolkit';
import { hrControlService } from './HRControl.service';
import { errorHandlerThunk } from '../../App/App.thunk';
import { CreateHRDto, UpdateHRDto } from './HRControl.type';

const THUNK_PREFIX = 'hrControl';

export const getHRControlListThunk = createAsyncThunk(
  `${THUNK_PREFIX}/getHRControlListThunk`,
  async (params: { q?: string; page?: number | string; sort?: string }, thunkAPI) => {
    try {
      const response = await hrControlService.getList(params);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const createHRControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/createHRControlThunk`,
  async (hr: CreateHRDto, thunkAPI) => {
    try {
      const response = await hrControlService.create(hr);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const updateHRControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/updateHRControlThunk`,
  async (hr: UpdateHRDto, thunkAPI) => {
    try {
      const response = await hrControlService.update(hr);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const deleteHRControlThunk = createAsyncThunk(
  `${THUNK_PREFIX}/deleteHRControlThunk`,
  async (id: number, thunkAPI) => {
    try {
      await hrControlService.delete(id);
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);
